export const Countries = {
  US: 'US',
  IN: 'India',
  UK: 'UK',
};

export const Currencies = {
  US: 'USD',
  IN: 'INR',
  UK: 'GBP',
};
